import { type DriveFile } from '@/shared/DriveTypes';
import { useRef } from 'react';
import { LEGACY } from '~/utils/constants';
import { useKeyPress } from '~/utils/hooks/hooks';
import registerComponent from '~/utils/registerComponent';
import { getViewInDriveUrl } from '~/utils/utils';
import * as styles from './Button.css';

const ViewInDrive = ({ file, email }: { file: DriveFile; email?: string | undefined }) => {
  const viewButtonRef = useRef<HTMLAnchorElement>(null);
  const href = getViewInDriveUrl(file, email);

  useKeyPress('v', () => viewButtonRef.current?.click());
  if (!href) return null;

  return (
    <a className={styles.viewInDrive} target="_blank" rel="noreferrer" href={href} ref={viewButtonRef}>
      View in
      <img
        className={styles.driveIcon}
        src="https://www.gstatic.com/images/branding/product/1x/drive_48dp.png"
        alt="Drive logo"
      />
    </a>
  );
};

if (LEGACY) {
  registerComponent(ViewInDrive, 'wc-view-in-drive', {
    file: 'json',
    email: 'string',
  });
}

export default ViewInDrive;
